import { datadogLogs } from '@datadog/browser-logs';
import { useUpdateOrganizationMembersMutation } from '@main/graphql/mutations/UpdateOrganizationMember.generated';
import { useStableCallback } from '@main/shared/browser';
import { toError } from '@main/shared/utils';
import { errorToast } from '@main/ui';

export const useUpdateUserStateAction = (refetchQuery: () => void) => {
  const [updateUser] = useUpdateOrganizationMembersMutation();

  return useStableCallback(
    async ({
      organizationIds,
      userIds,
      disabled,
    }: {
      organizationIds: string | string[];
      userIds: string | string[];
      disabled: boolean;
    }) => {
      try {
        await updateUser({
          organizationIds,
          userIds,
          organization_users_set_input: {
            disabled,
          },
        }).unwrap();

        refetchQuery();
      } catch (error) {
        errorToast('Failed to disable user(s).');
        datadogLogs.logger.error('User disable failed', {}, toError(error));
      }
    },
  );
};
